<template>
  <div class="emoji-pairs">
    <div v-for="row in iconRows">
      <span>{{ row.join("") }}</span>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        rows: [
          ["⬛","⬛","⬛","⬛"],
          ["⬛","⬛","⬛","⬛"],
          ["⬛","⬛","⬛","⬛"],
          ["⬛","⬛","⬛","⬛"]
        ]
      }
    },
    computed: {
      iconRows() {
        return this.rows;
      },
      activeRowIndexes() {
        let indexes = [];
        for (let [index, row] of this.rows.entries()) {
          if (row.filter(c => c === "⬛").length > 0) { indexes.push(index); }
        }
        return indexes;
      }
    },
    methods: {
      turnRandomPair: function() {
        if (this.activeRowIndexes.length === 0) {
          this.rows.splice(0,1,["⬛","⬛","⬛","⬛"]);
          this.rows.splice(1,1,["⬛","⬛","⬛","⬛"]);
          this.rows.splice(2,1,["⬛","⬛","⬛","⬛"]);
          this.rows.splice(3,1,["⬛","⬛","⬛","⬛"]);
          return;
        }
        let rowIndexes = [];
        let activeCellIndexes = function(row) {
          let indexes = [];
          for (let [index, cell] of row.entries()) { if (cell === "⬛") { indexes.push(index); }};
          return indexes;
        }
        let rows = this.rows;
        let activeRows = this.activeRowIndexes;

        [0,1].forEach((i) => {
          let rindex = this.activeRowIndexes.sort(() => 0.5 - Math.random())[0];
          rowIndexes.push(rindex);
          let row = this.rows[rindex];
          let index = activeCellIndexes(row).sort(() => 0.5 - Math.random())[0];
          row[index] = "✔️";
          this.rows.splice(rindex, 1, row);
        })

        setTimeout(function(){
          rowIndexes.forEach(function(i) {
            let row = rows[i].map(c => c === "✔️" ? "⬜" : (c === "⬜" ? "⬜" : "⬛"))
            rows.splice(i, 1, row);
          })
        }, 2000);
      }
    },
    mounted: function() {
      let vm = this
      setInterval(function(){ vm.turnRandomPair() }, 3000)
    }
  }
</script>
<style scoped>
  .emoji-pairs {
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/Animation.vue